import {
    FC,
    FormEvent,
    useRef,
    useState,
} from 'react'

import { FormActionButtons, TextInput } from '../../../compositions'
import { AddDistrictDivisionTemplateFormData } from '../../../entities/DistrictDivisionTemplate/DistrictDivisionTemplate'
import trans from '../../../helpers/trans'
import { ModalFormProps } from '../../../types/modalFormTypes'
import { AddDistrictDivisionTemplateFormErrors, validateAddDistrictDivisionTemplateFormData } from './validations/addDistrictDivisionTemplateFormValidation'

import './AddDistrictDivisionTemplateForm.scss'

interface AddDistrictDivisionTemplateFormProps extends ModalFormProps<AddDistrictDivisionTemplateFormData> {
    onSubmit: (addDistrictDivisionTemplateFormData: AddDistrictDivisionTemplateFormData) => void;
}

const AddDistrictDivisionTemplateForm: FC<AddDistrictDivisionTemplateFormProps> = ({
    isLoading,
    onSubmit,
    onCancel,
}) => {
    const [formData, setFormData] = useState<AddDistrictDivisionTemplateFormData>({ name: '' })
    const [formErrors, setFormErrors] = useState<AddDistrictDivisionTemplateFormErrors>({})
    const [name, setName] = useState<string>(formData.name)

    const formRef = useRef<HTMLFormElement>(null)

    const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault()

        const formDataToSubmit = { name }
        setFormData(formDataToSubmit)

        const [errors, hasErrors] = validateAddDistrictDivisionTemplateFormData(formDataToSubmit)
        setFormErrors(errors)

        if (! hasErrors) {
            onSubmit(formDataToSubmit)
        }
    }

    return (
        <form ref={formRef} onSubmit={handleSubmit} className="add-district-division-template-form">
            <div className="add-district-division-template-form__row">
                <div className="add-district-division-template-form__col">
                    <TextInput
                        label={trans('containers.forms.addDistrictDivisionTemplateForm.districtDivisionName')}
                        type="text"
                        value={name}
                        error={formErrors.name}
                        onChange={setName}
                    />
                </div>
            </div>
            <FormActionButtons
                isLoading={isLoading}
                disabled={! name}
                onCancelClick={onCancel}
            />
        </form>
    )
}

export default AddDistrictDivisionTemplateForm
